import { render, staticRenderFns } from "./FilterSection.vue?vue&type=template&id=4c70b2b8&scoped=true&"
import script from "./FilterSection.vue?vue&type=script&lang=js&"
export * from "./FilterSection.vue?vue&type=script&lang=js&"
import style0 from "./FilterSection.vue?vue&type=style&index=0&id=4c70b2b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c70b2b8",
  null
  
)

export default component.exports